import {ActivitiesGroup} from '../../../../../../backend/interfaces/activities-group';
import {ActivityType} from '../../../../../../backend/interfaces/activity-type';
import {CareTask} from '../../../../../../backend/interfaces/care-task';
import {EntityPendingTask} from '../../../../../../backend/interfaces/entity-pending-task';
import {EntityUser} from '../../../../../../backend/responses/entity-user';
import {EntityActivitiesRepository} from '../../../../../../repositories/entity-activities';
import {EntityUsersRepository} from '../../../../../../repositories/entity-users';

export type PendingTask = {
  id: string;
  picture: string;
  socialResponses: string[];
  date: Date;
  group: string;
  type: string;
  selected: boolean;
  userId: string;
  ref: string;
  sectorId: string;
  entityShiftIds?: string[];
};

type PendingsTasks = {
  [id: string]: PendingTask;
};

export const formatPendingTask = async (
  entityId: string,
  data: {pendingCareTask: EntityPendingTask; careTask: CareTask}[]
): Promise<PendingsTasks> => {
  const types: {[id: string]: string} = {};
  const groups: {[id: string]: string} = {};
  const users: {[id: string]: EntityUser} = {};
  const formattedTasks: PendingsTasks = {};
  const typesRequests: Promise<ActivityType | null>[] = [];
  const groupsRequests: Promise<ActivitiesGroup | null>[] = [];
  const usersRequests: Promise<EntityUser>[] = [];
  const typesRequestsIds: string[] = [];
  const groupsRequestsIds: string[] = [];
  const usersRquestsIds: string[] = [];

  data.forEach((task) => {
    formattedTasks[task.pendingCareTask.id] = {
      id: task.pendingCareTask.id,
      picture: users[task.careTask.userId]?.user.picture || '',
      date: task.careTask.startsAt,
      group: groups[task.careTask.activitiesGroupId] || '',
      type: types[task.careTask.activityTypeId] || '',
      socialResponses: users[task.careTask.userId]?.affiliation.socialResponses || [],
      selected: true,
      userId: task.careTask.userId,
      ref: task.careTask.ref,
      sectorId: task.careTask.activitiesSectorId,
      entityShiftIds: task.careTask.entityShiftIds,
    };
    if (!typesRequestsIds.includes(task.careTask.activityTypeId)) {
      typesRequestsIds.push(task.careTask.activityTypeId);
      typesRequests.push(
        EntityActivitiesRepository.instance.getType(
          entityId,
          task.careTask.activitiesSectorId,
          task.careTask.activitiesGroupId,
          task.careTask.activityTypeId
        )
      );
    }
    if (!groupsRequestsIds.includes(task.careTask.activitiesGroupId)) {
      groupsRequestsIds.push(task.careTask.activitiesGroupId);
      groupsRequests.push(
        EntityActivitiesRepository.instance.getGroup(
          entityId,
          task.careTask.activitiesSectorId,
          task.careTask.activitiesGroupId
        )
      );
    }
    if (!usersRquestsIds.includes(task.careTask.userId)) {
      usersRquestsIds.push(task.careTask.userId);
      usersRequests.push(EntityUsersRepository.instance.getById(entityId, task.careTask.userId));
    }
  });

  const [typesResponses, groupsResponses, usersResponsesSettled] = await Promise.all([
    Promise.all(typesRequests),
    Promise.all(groupsRequests),
    Promise.allSettled(usersRequests),
  ]);

  typesResponses.forEach((response) => {
    if (response?.id) types[response.id] = response?.name;
  });

  groupsResponses.forEach((response) => {
    if (response?.id) groups[response.id] = response?.name;
  });

  usersResponsesSettled
    // Only take fulfilled user responses (avoid crashes if user not found)
    .filter((result) => result.status === 'fulfilled')
    // Tell TypeScript that the result are EntityUsers
    .map((result) => (result as PromiseFulfilledResult<EntityUser>).value)
    .forEach((response) => {
      if (response?.user.id) users[response.user.id] = response;
    });

  data.forEach((task) => {
    formattedTasks[task.pendingCareTask.id].type = types[task.careTask.activityTypeId] || '';
    formattedTasks[task.pendingCareTask.id].group = groups[task.careTask.activitiesGroupId] || '';
    formattedTasks[task.pendingCareTask.id].picture =
      users[task.careTask.userId]?.user.picture || '';
    formattedTasks[task.pendingCareTask.id].socialResponses =
      users[task.careTask.userId]?.affiliation.socialResponses || [];
  });

  return formattedTasks;
};
